import { useLocalization } from 'src/utils/useLocalization';
import './styles.scss';
interface IProps {
    accountType: string;
}
const Payment = ({ accountType }: IProps) => {
    const { payoffQuotesQuoteDetails } = useLocalization();
    return (
        <section className='c-form-section quote-payment-info'>
            <div className='c-form-section__content'>
                <div className='title'>
                    <h6>
                        <span className='c-section-heading__title-text u-mr-xxsmall section-title'>
                            {payoffQuotesQuoteDetails.PAYMENT_TITLE}
                        </span>
                    </h6>
                </div>
                <div className='o-fieldset__row u-mt-large u-mb-large'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <div className='field-show'>
                                <span className='checkbox-cage'></span>
                                <span className='label'>
                                    {
                                        payoffQuotesQuoteDetails.PAYMENT_CHECKS_DIGITAL
                                    }
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='checkbox-cage'></span>
                                <span className='label'>
                                    {
                                        payoffQuotesQuoteDetails.PAYMENT_CHECKS_BRASS
                                    }
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    <p>
                                        <strong>
                                            {
                                                payoffQuotesQuoteDetails.PAYMENT_NOTE_LABEL
                                            }
                                        </strong>
                                        :{' '}
                                        {payoffQuotesQuoteDetails.PAYMENT_NOTE}
                                    </p>
                                </span>
                            </div>
                            {accountType == 'OperatingLease' && (
                                <div className='field-show'>
                                    <span className='label'>
                                        <p>
                                            {
                                                payoffQuotesQuoteDetails.AUTHORIZATION_NOTE
                                            }
                                        </p>
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Payment;
